import styled from 'styled-components'

export const WaringText = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${(p) => p.theme.status.danger.text};
`
